import React from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import FirstLogin from "../pages/Authentication/FirstLogin";

const AuthProtected = (props) => {
  const location = useLocation();
  const user = useSelector(state => state?.user?.currentUser);

  if (isEmpty(user)) {
    return (
      <Navigate to="/login" state={{ from: location }} replace />
    );
  }

  if (Number(user?.first_login) === 1) {
    return <FirstLogin />;
  }

  return <>{props.children}</>;
};


const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };

